<template>
  <div class="mt-3 main-theme bg-white-border p-3">
    <div class="">
      <b-row class="pt-2">
        <b-col cols="6">
          <VueSelect
            title="Channel"
            name="brand"
            isRequired
            v-model="form.platformConfigId"
            :options="platformIdList"
            valueField="id"
            textField="name"
            imageField="imageUrl"
            :clearable="false"
            :disabled="this.id ? true : false"
            @onDataChange="(val) => (form.platformConfigId = val)"
            :isValidate="$v.form.platformConfigId.$error"
            :v="$v.form.platformConfigId"
          />
          <div class="text-error-wrp" v-if="$v.form.platformConfigId.$error">
            <span
              class="text-error"
              v-if="!$v.form.platformConfigId.notSelect99"
              >Select Brand</span
            >
          </div>
        </b-col>
        <b-col cols="6">
          <InputSelect
            title="Form"
            name="Form"
            isRequired
            :options="formSettingList"
            valueField="id"
            textField="name"
            v-model="form.formId"
            @onDataChange="(val) => (form.formId = val)"
            :isValidate="$v.form.formId.$error"
            :v="$v.form.formId"
        /></b-col>
      </b-row>
      <b-row class="pt-2"
        ><b-col cols="6">
          <b-form-checkbox
            class="input-label"
            v-model="form.isAutoSendForm"
            :value="1"
            :unchecked-value="0"
            >Auto Sent Form</b-form-checkbox
          ></b-col
        ></b-row
      >
      <b-row class="pt-2" v-if="form.isAutoSendForm == 1">
        <b-col cols="12">
          <div>
            <p class="input-label">Topic <span class="text-danger">*</span></p>
          </div>

          <div :class="{ errorClass: $v.form.topicIds.$error }">
            <multiselect
              id="topics-dropdown"
              v-model="form.topicIds"
              :options="conversationTopicsFilter"
              :multiple="true"
              :group-select="false"
              :close-on-select="false"
              placeholder="Select Topic"
              track-by="id"
              label="name"
              :option-disabled="(option) => option.isGroup"
            >
              <!-- @input="onSelectOption" -->
              <template v-slot:noResult>ไม่พบข้อมูล</template>
              <template #option="{ option }">
                <div
                  v-if="option.isGroup"
                  class="group-header"
                  @mousedown.prevent
                  @click.prevent.stop="toggleGroup(option.groupName)"
                >
                  <div class="group-name">
                    {{ option.groupName }}
                  </div>
                  <div class="group-icon">
                    {{ topicsGroups.includes(option.groupName) ? "▼" : "►" }}
                  </div>
                </div>
                <div
                  :class="
                    !option.isGroup &&
                    option.groupName &&
                    !topicsGroups.includes(option.groupName)
                      ? 'group-item'
                      : 'item'
                  "
                >
                  {{ option.name }}
                </div>
              </template>
            </multiselect>
          </div>
        </b-col></b-row
      >

      <b-row class="pt-2" v-if="form.isAutoSendForm == 1">
        <b-col cols="6">
          <div :class="{ errorClass: $v.form.validTo.$error }">
            <p class="input-label">
              Valid Form <span class="text-danger">*</span>
            </p>
            <datetime
              v-model="form.validFrom"
              type="datetime"
              class="date-picker-input"
              value-zone="Asia/Bangkok"
              placeholder="dd/mm/yyyy (hh:mm)"
              :max-datetime="maxValidForm"
            ></datetime>
            <div v-if="$v.form.validFrom.$error">
              <span class="text-error" v-if="$v.form.validFrom.$error">
                กรุณาเลือกวันที่
              </span>
            </div>
          </div>
        </b-col>
        <b-col cols="6">
          <div :class="{ errorClass: $v.form.validTo.$error }">
            <p class="input-label">
              Valid To <span class="text-danger">*</span>
            </p>
            <datetime
              type="datetime"
              v-model="form.validTo"
              class="date-picker-input"
              value-zone="Asia/Bangkok"
              placeholder="dd/mm/yyyy (hh:mm)"
              :min-datetime="minValidTo"
            ></datetime>
          </div>
          <div v-if="$v.form.validTo.$error">
            <span class="text-error" v-if="$v.form.validTo.$error">
              กรุณาเลือกวันที่
            </span>
          </div>
        </b-col>
      </b-row>
      <b-row class="pt-2" v-if="form.isAutoSendForm == 1">
        <b-col cols="3">
          <InputNumber
            v-model="form.randomRate"
            textFloat="Random Rate"
            placeholder="Random Rate"
            type="number"
            suffix="%"
            name="randomRate"
            isRequired
            :isValidate="$v.form.randomRate.$error"
            :v="$v.form.randomRate"
          />
        </b-col>
      </b-row>
    </div>
    <hr />
    <div class="w-100 d-flex justify-content-between">
      <b-button
        class="btn-cancel tn-details-set text-uppercase px-5"
        @click="handleClickCancel()"
        :disabled="isLoading"
        >CANCEL</b-button
      >
      <button
        type="button"
        class="btn btn-main btn-details-set ml-md-2 text-uppercase"
        @click="handleClickSave()"
        :disabled="isLoading"
      >
        SAVE
      </button>
    </div>
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
import Multiselect from "vue-multiselect";
import VueSelect from "@/components/inputs/VueSelect";
import InputNumber from "@/components/inputs/InputNumber";
import moment from "moment";
import {
  required,
  requiredIf,
  minValue,
  integer,
  minLength,
  maxValue,
} from "vuelidate/lib/validators";
import ModalLoading from "@/components/modal/alert/ModalLoading";

export default {
  name: "CastChannelSettingForm",
  components: {
    InputSelect,
    Multiselect,
    VueSelect,
    InputNumber,
    ModalLoading,
  },
  validations() {
    return {
      form: {
        platformConfigId: {
          notSelect99: (value) => value !== 99,
        },
        formId: { required },
        validFrom: {
          requiredIf: requiredIf(function (item) {
            return this.form.isAutoSendForm == 1;
          }),
        },
        validTo: {
          requiredIf: requiredIf(function (item) {
            return this.form.isAutoSendForm == 1;
          }),
        },
        randomRate: {
          integer,
          minValue: minValue(0),
          maxValue: maxValue(100),
          requiredIf: requiredIf(function (item) {
            return this.form.isAutoSendForm == 1;
          }),
        },
        topicIds: {
          minLength: minLength(1),
          requiredIf: requiredIf(function (item) {
            return this.form.isAutoSendForm == 1;
          }),
        },
      },
    };
  },
  data() {
    return {
      id: this.$route.params.id,
      isLoading: false,
      conversationTopics: [],
      form: {
        validFrom: null,
        validTo: null,
        topicIds: [],
        platformConfigId: 99,
        isAutoSendForm: 0,
        formId: null,
      },
      topicsGroups: [],
      platformIdList: [],
      formSettingList: [],
    };
  },

  computed: {
    maxValidForm() {
      return this.form.validTo
        ? moment(this.form.validTo).endOf("day").format()
        : null;
    },
    minValidTo() {
      return this.form.validFrom
        ? moment(this.form.validFrom).startOf("day").format()
        : null;
    },
    conversationTopicsFilter() {
      return this.conversationTopics.flatMap((group) => {
        const hasGroup = group.groupName;

        const headerGroup = hasGroup
          ? [{ isGroup: true, groupName: group.groupName }]
          : [];

        const items = group.topics.map((item) => ({
          ...item,
          groupName: group.groupName || null,
        }));

        return [...headerGroup, ...items];
      });
    },
  },
  async created() {
    this.isLoading = true;
    await this.getConversationTopics();
    await this.getFormSetting();

    if (this.id) {
      await this.getAllPlatformConfig();
      await this.getDetail();
    } else {
      await this.getPlatformList();
    }

    this.isLoading = false;
  },

  watch: {
    isLoading(val) {
      if (val) this.$refs.modalLoading.show();
      else this.$refs.modalLoading.hide();
    },
    "form.topicIds"(newVal, oldVal) {
      const newHasAll = newVal?.some((e) => e.id === 0);
      const oldHasAll = oldVal?.some((e) => e.id === 0);

      if (!oldHasAll && newHasAll) {
        this.conversationTopics.forEach((group) => {
          group.topics.forEach((topic) => {
            if (!this.form.topicIds.some((t) => t.id === topic.id)) {
              this.form.topicIds.push(topic);
            }
          });
        });
      }

      if (oldHasAll && !newHasAll) {
        this.form.topicIds = [];
      }
    },
  },
  methods: {
    getDetail: async function () {
      const response = await this.axios.get(
        `${this.$baseUrl}/csat/Ch/Detail/${this.id}`
      );
      if (response?.result == 1) {
        this.form = response.detail;

        const topicIds = response.detail?.topicIds || [];

        this.form.topicIds = [];

        this.conversationTopics?.forEach((group) => {
          group.topics.forEach((topic) => {
            if (topicIds.includes(topic.id)) {
              this.form.topicIds.push(topic);
            }
          });
        });
      }
    },
    getConversationTopics: async function () {
      const response = await this.axios(`${this.$baseUrl}/FlowBuilder/Topics`);
      if (response && response.result == 1) {
        if (response.detail.length > 0) {
          const { detail } = response;
          detail.forEach((group) => {
            if (group.groupIsActive === true || group.groupId === 0) {
              let addTopics = [];

              if (group.groupId === 0) {
                const allTopics = {
                  id: 0,
                  name: "All Topics",
                  sortOrder: 0,
                  isActive: true,
                  topicGroupId: 0,
                };
                addTopics.push(allTopics);
              }
              const filterActive = group.topics.filter(
                (item) => item.isActive === true
              );
              addTopics = addTopics.concat(filterActive);
              const addGroup = {
                ...group,
                topics: addTopics,
              };
              this.conversationTopics.push(addGroup);
            }
          });
        }
      }
    },
    getPlatformList: async function () {
      this.platformIdList = [];

      const response = await this.axios.get(
        `${this.$baseUrl}/csat/Ch/ListPlatformConfigs`
      );
      this.platformIdList.push({ id: 99, name: "Select Brand" });

      if (response && response.result == 1) {
        const list = response.detail.map((item) => ({
          id: item.platformConfigId,
          name: item.channelName
            ? item.name + " - " + item.channelName
            : item.name,
          imageUrl: item.imageUrl,
        }));
        this.platformIdList = this.platformIdList.concat(list);
      }
    },
    getAllPlatformConfig: async function () {
      const url = `${this.$baseUrl}/analytics/get-all-platform-config`;
      await this.axios.get(url).then(async (data) => {
        if (data.result === 1) {
          const list = data.detail.map((item) => ({
            id: item.platformConfigId,
            name: item.channelName
              ? item.name + " - " + item.channelName
              : item.name,
            imageUrl: item.imageUrl,
          }));
          this.platformIdList = this.platformIdList.concat(list);
        }
      });
    },
    async getFormSetting() {
      const response = await this.axios.get(
        `${this.$baseUrl}/csat/Ch/ListFormSetting`
      );
      if (response && response.result == 1) {
        this.formSettingList = response.detail;
      }
    },
    async handleClickSave() {
      this.$v.$touch();
      if (this.$v.$error) return;
      this.isLoading = true;
      try {
        let payload = {
          ...this.form,
        };
        if (this.form.topicIds.length > 0) {
          payload.topicIds = this.form.topicIds.map((e) => e.id);
        }
        const response = await this.axios.post(
          `${this.$baseUrl}/csat/Ch/CreateUpdate`,
          payload
        );
        if (response && response.result == 1) {
          this.$store.commit("UPDATE_GLOBAL_ALERT", {
            isShow: true,
            msg: response.message,
          });
        } else {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: response.message || "บันทึกไม่สําเร็จ",
          });
        }
        this.isLoading = false;
        this.$router.push({ path: "/csat/channel-setting" }).catch(() => {});
      } catch (err) {
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: err.message || "บันทึกไม่สําเร็จ",
        });
        this.isLoading = false;
      }
    },
    handleClickCancel() {
      this.$router.push({ path: "/csat/channel-setting" }).catch(() => {});
    },
    toggleGroup(groupName) {
      const index = this.topicsGroups.indexOf(groupName);
      if (index > -1) {
        this.topicsGroups.splice(index, 1);
      } else {
        this.topicsGroups.push(groupName);
      }
      this.form.topicIds = this.form.topicIds.filter((item) => !item.isGroup);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-label {
  color: #404040;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}
::v-deep .multiselect__option {
  :has(.group-header) {
    padding: 0 !important;
  }
}
::v-deep .multiselect__element {
  :has(.group-header) {
    color: #35495e;
    background-color: #f0f0f0;
    padding: 0 !important;
    &:hover {
      background-color: #b41bb4;
      color: #ffffff;
    }

    &::after {
      display: none;
    }
  }

  :has(.group-item) {
    display: none !important;
  }

  span {
    padding-left: 10px;
  }
}

::v-deep .multiselect__tag {
  max-width: 300px;
}

::v-deep .multiselect__element {
  span {
    min-width: 100%;
    max-width: 390px;
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.group-header {
  padding: 12px 12px 15px 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: #f0f0f0;

  .group-icon {
    font-size: 10px;
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
  }
}

.group-header:hover {
  background-color: #b41bb4;
}

.group-item,
.item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding-left: 10px;
}
.text-error-wrp {
  position: absolute !important;
  bottom: 11px;
}
</style>
